import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"




export default class extends Controller {
  static values = {
    loadUrl: String,
    loadParam: { type: String, default: "q" },
    minQueryLength: { type: Number, default: 3 },
    valueField: { type: String, default: "id" },
    labelField: { type: String, default: "name" },
    searchField: { type: String, default: "name" },
    placeholder: { type: String, default: "Select an option..." },
    allowEmptyOption: { type: Boolean, default: false },
    create: { type: Boolean, default: false }
  }

  connect() {
    this.initializeTomSelect()
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy()
      this.tomSelect = null
    }
  }

  initializeTomSelect() {
    const select = this.element

    const options = {
      valueField: this.valueFieldValue,
      labelField: this.labelFieldValue,
      searchField: this.searchFieldValue,
      placeholder: this.placeholderValue,
      allowEmptyOption: this.allowEmptyOptionValue,
      create: this.createValue,
      plugins: []
    }


    options.load = (query, callback) => {
      if (!this.loadUrlValue) {
        callback()
        return
      }

      if (query.length < this.minQueryLengthValue) {
        callback()
        return
      }

      const url = new URL(this.loadUrlValue, window.location.origin)
      url.searchParams.set(this.loadParamValue, query)

      fetch(url)
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
          }
          return response.json()
        })
        .then(data => {
          // Transform data to Tom Select format
          const items = Array.isArray(data) ? data : data.items || []
          callback(items)
        })
        .catch(error => {
          console.error("Error loading options:", error)
          callback()
        })
    }

    this.tomSelect = new TomSelect(select, options)
  }

  // Public method to reload options
  reload() {
    if (this.tomSelect && this.loadUrlValue) {
      this.tomSelect.load((query, callback) => {
        const url = new URL(this.loadUrlValue, window.location.origin)
        if (query) {
          url.searchParams.set(this.loadParamValue, query)
        }

        fetch(url)
          .then(response => response.json())
          .then(data => {
            const items = Array.isArray(data) ? data : data.items || []
            callback(items)
          })
          .catch(error => {
            console.error("Error reloading options:", error)
            callback()
          })
      })
    }
  }

  // Public method to clear options
  clearOptions() {
    if (this.tomSelect) {
      this.tomSelect.clearOptions()
    }
  }

  // Public method to disable control
  disable() {
    if (this.tomSelect) {
      this.tomSelect.disable()
    }
  }

  // Public method to enable control
  enable() {
    if (this.tomSelect) {
      this.tomSelect.enable()
    }
  }

  // Public method to clear selection
  clear() {
    if (this.tomSelect) {
      this.tomSelect.clear()
    }
  }

  // Public method to set value
  setValue(value) {
    if (this.tomSelect) {
      this.tomSelect.setValue(value)
    }
  }
}
